import styled from 'styled-components'

const BilansSummaryStyle = styled.div`
  .summary {
    width: 100%;
    display: grid;
    grid-template-columns: 1fr auto;
    grid-template-areas: 'summaryName summaryData';
    padding-right: 24px;

    background-color: ${props => props.theme.primary50};
  }

  .summaryName {
    padding-left: 20px;
    grid-area: summaryName;
    display: flex;
    align-items: center;

    font-family: Ubuntu;
    font-size: 11px;
    font-weight: bold;
    line-height: 1.45;
    letter-spacing: 1.5px;
    color: var(--black-60);
  }

  .summaryData {
    grid-area: summaryData;
    padding: 8px 0;

    .summary-row {
      display: grid;
      grid-template-columns: 144px 144px 144px auto;
      height: 28px;
      text-align: right;
      padding-right: 16px;

      .title {
        font-family: Ubuntu;
        font-size: 11px;
        line-height: 1.45;
        letter-spacing: 0.4px;
        color: var(--black-60);
        display: flex;
        align-items: center;
        justify-content: flex-end;
        &.error {
          color: ${props => props.theme.error};
        }
      }

      .kwota {
        font-family: Ubuntu;
        font-size: 16px;
        line-height: 1.75;
        letter-spacing: 0.3px;
        color: rgba(0, 0, 0, 0.87);
        &.error {
          color: ${props => props.theme.error};
        }
      }

      .kwota.b1 {
        width: 160px;
      }
    }
  }
`

export default BilansSummaryStyle
